import { TextCell } from "@similarweb/pro-logic-components";

import { getItemPlusNValue } from "app/pages/sales-intelligence/common-components/table-cells";
import type { LeadsSearchRow } from "app/pages/sales-intelligence/modules/leads-search";
import { StyledCenteredBaseCell } from "app/pages/sales-intelligence/sub-modules/signals/containers/cells/SignalTechnologyCellContainer/styles";
import type {
    IUseTrackedSignalTooltipResponse } from "app/pages/sales-intelligence/sub-modules/signals/hooks/cells/useTrackedSignalTooltip";
import {
    useTrackedSignalTooltip,
} from "app/pages/sales-intelligence/sub-modules/signals/hooks/cells/useTrackedSignalTooltip";
import type TechnologySignalRowDto from "app/pages/sales-intelligence/sub-modules/signals/models/technology/TechnologySignalRowDto";
import TechnologySignalSubType from "app/pages/sales-intelligence/sub-modules/signals/models/technology/TechnologySignalSubType";
import type { TechnologyColumnNames } from "app/pages/sales-intelligence/sub-modules/signals/types";

import { SignalsTechnologyTooltipContainer } from "../SignalsTechnologyTooltipContainer/SignalsTechnologyTooltipContainer";

interface ISignalTechnologyCellContainerProps<V extends LeadsSearchRow> {
    field: TechnologyColumnNames;
    record: V;
}

export const SignalTechnologyCellContainer = <V extends LeadsSearchRow>({
    field,
    record,
}: ISignalTechnologyCellContainerProps<V>) => {
    const value = record[field] ?? [];
    const technologyValue = Array.isArray(value) ? value : [value];
    const { onTrackedTooltipClick }: IUseTrackedSignalTooltipResponse = useTrackedSignalTooltip({
        field,
        value: technologyValue.length,
    });

    const getTechnologiesNames = (technologies: readonly TechnologySignalRowDto[]): readonly string[] => {
        return technologies.map(({ name }) => name);
    };

    const cellText = getItemPlusNValue(getTechnologiesNames(value));

    return (
        <SignalsTechnologyTooltipContainer
            value={value}
            field={field}
            onViewAll={onTrackedTooltipClick}
            signalSubType={TechnologySignalSubType.AddedTechnologies}
            row={record}
        >
            <StyledCenteredBaseCell>
                <TextCell dataAutomation="technology-cell">{cellText}</TextCell>
            </StyledCenteredBaseCell>
        </SignalsTechnologyTooltipContainer>
    );
};
